import * as types from '../types/collectionTypes';
import { USE_API } from '../../config/env';
import { modamaiTrace } from '../../utils/modamaiTrace';
import { collectionService } from '../../services/collectionService';

const errMsg = (error) =>
  error?.response?.data?.message || error?.message || 'Request failed';

export const clearCollectionDetail = () => ({ type: types.CLEAR_COLLECTION_DETAIL });

export const fetchCollections = () => async (dispatch) => {
  if (!USE_API) {
    modamaiTrace('fetchCollections skipped (USE_API off)', {});
    return;
  }
  modamaiTrace('fetchCollections START', {});
  dispatch({ type: types.FETCH_COLLECTIONS_REQUEST });
  try {
    const list = await collectionService.list();
    modamaiTrace('fetchCollections SUCCESS', {
      len: Array.isArray(list) ? list.length : 'not-array',
    });
    dispatch({ type: types.FETCH_COLLECTIONS_SUCCESS, payload: list });
  } catch (e) {
    const msg = errMsg(e);
    modamaiTrace('fetchCollections FAILURE', { msg, status: e?.response?.status });
    dispatch({
      type: types.FETCH_COLLECTIONS_FAILURE,
      payload: msg,
    });
  }
};

/** Load one collection by slug; stores raw API payload in `collection.detail` (incl. `products`). */
export const fetchCollectionDetail = (slug, locale) => async (dispatch) => {
  if (!USE_API) {
    modamaiTrace('fetchCollectionDetail skipped', { slug });
    return;
  }
  const normalized = String(slug || '').trim();
  if (!normalized) {
    modamaiTrace('fetchCollectionDetail no slug', {});
    dispatch({
      type: types.FETCH_COLLECTION_DETAIL_FAILURE,
      payload: { message: 'Missing slug' },
    });
    return;
  }
  modamaiTrace('fetchCollectionDetail START', { slug: normalized });
  dispatch({ type: types.FETCH_COLLECTION_DETAIL_REQUEST });
  try {
    const raw = await collectionService.getBySlug(normalized, locale);
    if (!raw || !raw.slug) {
      modamaiTrace('fetchCollectionDetail not found', {
        slug: normalized,
        hasRaw: Boolean(raw),
      });
      dispatch({
        type: types.FETCH_COLLECTION_DETAIL_FAILURE,
        payload: { message: 'Collection not found', status: 404 },
      });
      return;
    }
    modamaiTrace('fetchCollectionDetail SUCCESS', {
      slug: raw.slug,
      productsRawLen: Array.isArray(raw.products) ? raw.products.length : null,
    });
    dispatch({
      type: types.FETCH_COLLECTION_DETAIL_SUCCESS,
      payload: raw,
    });
  } catch (e) {
    const status = e?.response?.status;
    const msg = errMsg(e);
    modamaiTrace('fetchCollectionDetail FAILURE', { slug: normalized, msg, status });
    dispatch({
      type: types.FETCH_COLLECTION_DETAIL_FAILURE,
      payload: { message: msg, status },
    });
  }
};

/** Alias matching `maison/client` naming. */
export const fetchCollectionBySlug = fetchCollectionDetail;
